<template>
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
<path fill="#56D0E0" d="M85 235v42h43v-42h-43zM43 299v-86h426v86h-426zM128 149v-42h-43v42h43zM43 85h426v86h-426v-86zM85 363v42h43v-42h-43zM43 427v-86h426v86h-426z"></path>
</svg>
</template>
